import {Cadastrao} from "../shared/cadastrao";
import {BaseBean} from "../shared/base-bean";
import {PermUsuario} from "./perm-usuario";

export class Usuario extends BaseBean {

  public _explicitType: string = 'br.com.sgsistemas.cotacao.cotacaoweb.beans.Usuario';

  public id: number;
  public cadastrao: Cadastrao;
  public login: string;
  public senha: string;
  public nome: string;
  public email: string;
  public tipo: string;
  public situacao: string;
  public permissoes: PermUsuario[];
  public agrupaCotacao: string;
  public chave: string;
  public dtExpiraChave: Date;
  public agrupafornecedor: string;

  constructor(id?: number,
              cadastrao?: Cadastrao,
              login?: string,
              senha?: string,
              nome?: string,
              email?: string,
              tipo?: string,
              situacao?: string,
              permissoes?: PermUsuario[],
              agrupaCotacao?: string,
              chave?: string,
              dtExpiraChave?: Date,
              agrupafornecedor?: string) {
    super(id);
    this.id = id;
    this.cadastrao = cadastrao;
    this.login = login;
    this.senha = senha;
    this.nome = nome;
    this.email = email;
    this.tipo = tipo;
    this.situacao = situacao;
    this.permissoes = permissoes;
    this.agrupaCotacao = agrupaCotacao;
    this.chave = chave;
    this.dtExpiraChave = dtExpiraChave;
    this.agrupafornecedor = agrupafornecedor;
  }
}
